import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { ProgereBrand } from "@/components/ProgereBrand";
import { ShieldCheck } from "lucide-react";

export default function PlatformInvitationPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [inv, setInv] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!token) { setError("Lien invalide."); return; }
    api.get(`/platform/employees/invitation/${token}`)
      .then(({ data }) => setInv(data))
      .catch((e) => setError(formatApiError(e.response?.data?.detail) || "Invitation invalide ou expirée."));
  }, [token]);

  const accept = async () => {
    if (password.length < 8) { toast.error("Mot de passe : 8 caractères minimum"); return; }
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setSaving(true);
    try {
      const { data } = await api.post("/platform/employees/accept", { token, password });
      localStorage.setItem("pg_token", data.token);
      toast.success("Accès interne créé");
      window.location.href = "/app";
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Erreur"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full rounded-lg border border-white/15 bg-black/40 px-3 py-2.5 text-sm text-white placeholder:text-white/30 focus:border-[#EAB308] focus:outline-none";

  return (
    <div className="min-h-screen progere-page flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl border border-white/12 bg-[#0e0f13] p-8" data-testid="platform-invitation-page">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#EAB308]/40 bg-[#EAB308]/10"><ShieldCheck className="w-5 h-5 text-[#EAB308]" /></div>
          <div><ProgereBrand module="INTERNE" size="medium" /><div className="text-xs text-white/50">Accès interne sécurisé</div></div>
        </div>

        {error && <p className="rounded-lg bg-red-500/10 p-3 text-sm text-red-300" data-testid="invite-error">{error}</p>}

        {inv && (
          <div className="space-y-4">
            <p className="text-sm text-white/70">Bonjour <b className="text-white">{inv.first_name}</b>, vous êtes invité·e comme <b className="text-[#EAB308]">{inv.role_label}</b>. Créez votre mot de passe.</p>
            <div className="rounded-lg bg-black/40 px-3 py-2 text-sm text-white/60">{inv.email}</div>
            <input type="password" className={inputCls} placeholder="Mot de passe (8 car. min)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password" />
            <input type="password" className={inputCls} placeholder="Confirmer le mot de passe" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="invite-confirm" />
            <button onClick={accept} disabled={saving} data-testid="invite-accept" className="w-full rounded-lg bg-[#EAB308] px-6 py-2.5 text-sm font-bold text-black hover:bg-[#ffd45c] disabled:opacity-50">
              {saving ? "Création…" : "Créer mon accès"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
